import { makeStyles, Theme } from '@material-ui/core';
import { style } from 'commons/constants/KeyFlowConstants';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    msUserSelect: 'none',
    MozUserSelect: 'none',
    KhtmlUserSelect: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none',
  },
  opacity: {
    opacity: '0',
  },
  displayNone: {
    display: 'none',
  },
  opacity0: {
    opacity: 0,
  },
  opacity1: {
    opacity: 1.0,
  },
  errorContainer: {
    position: 'absolute',
    zIndex: theme.zIndex.modal - 1,
    width: '100%',
    height: '100%',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  errorContent: {
    paddingTop: '20%',
  },
  errorTitle: {
    color: theme.palette.common.white,
  },
  videoLoadingProgress: {
    fontSize: '100px',
    color: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      fontSize: '50px',
    },
  },
  videoContainer: {
    height: 0,
    cursor: 'pointer',
    paddingBottom: '56.26%',
    '& > video': {
      position: 'absolute',
      width: '100%',
      height: 'auto',
    },
  },
  coverContainer: {
    position: 'absolute',
    zIndex: theme.zIndex.modal - 1,
    top: '30%',
    textAlign: 'center',
    width: '100%',
    '& > *': {
      width: '100px',
      color: theme.palette.common.white,
      transition: 'all linear 0.25s',
      filter: 'drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.5))',
      [theme.breakpoints.down('sm')]: {
        width: '50px',
      },
    },
  },
  functionContainer: {
    position: 'relative',
    backgroundColor: style.PREVIEW_CONTENTS_BACKGROUND_COLOR,
  },
  skimContainer: {
    position: 'absolute',
    top: '-150px',
    width: '100%',
  },
  skim: {
    position: 'relative',
    width: '240px',
    height: '135px',
    overflow: 'hidden',
    backgroundOrigin: 'content-box',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  time: {
    position: 'relative',
    top: '110px',
    width: '100%',
    textAlign: 'center',
    '& > span': {
      backgroundColor: 'rgb(0, 0, 0, 0.6)',
      color: 'rgba(255,255,255,1.0)',
      fontWeight: 'bold',
      padding: '2.5px 10px 2.5px 10px',
      borderRadius: '2px 2px 2px 2px',
    },
  },
  progressBarContainer: {
    position: 'relative',
    height: '20px',
    backgroundColor: 'rgba(202, 90, 150, 1.0)',
    [theme.breakpoints.down('md')]: {
      height: '20px',
    },
  },
  progressBar: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  bufferBar: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
  scrubbingBar: {
    zIndex: 3,
    position: 'absolute',
    borderRight: '1px solid white',
    width: '1px',
    height: '100%',
  },
  inOutContainer: {
    position: 'relative',
    height: '25px',
  },

  pointContainer: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
  },
  inPointContainer: {
    left: 0,
    '&:hover': {
      zIndex: theme.zIndex.tooltip,
      '&::after': {
        content: '"Start"',
        color: '#ffffff',
      },
    },
  },
  outPointContainer: {
    right: 0,
    '&:hover': {
      zIndex: theme.zIndex.tooltip,
      '&::before': {
        content: '"Finish"',
        color: '#ffffff',
      },
    },
  },
  point: {
    width: '15px',
    cursor: 'pointer',
    color: '#ffffff',
  },

  timeContainer: {
    height: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 10px 0 10px',
    color: '#ffffff',
    [theme.breakpoints.down('md')]: {
      padding: '0 15px 0 15px',
    },
  },

  controllerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#ffffff',
    position: 'relative',
    [theme.breakpoints.down('xs')]: { padding: '12px' },
  },
  iconButton: {
    color: '#ffffff',

    padding: '8px',
    [theme.breakpoints.down('xs')]: {
      padding: '2px',
    },
  },
  soundController: {
    width: '28px',
  },
  soundControllerContainer: {
    width: '28px',
    height: '100px',
    position: 'absolute',
    // -(컨테이너 높이 + 여백(8px))
    top: '-108px',
    // -(컨테이너크기 - 아이콘크기) / 2
    left: '8px',
    zIndex: 2000,
    background: 'black',
    padding: '10px 0px',
    borderRadius: '20px',
    // 기존 left - (기존 padding(20px) - 모바일용 padding(2px)) / 2
    [theme.breakpoints.down('xs')]: { left: '-1px' },
  },
  soundControllerHidden: {
    display: 'none',
  },
  playbackRateControllerContainer: {
    width: '164px',
    position: 'absolute',
    // -(컨테이너 높이 + 여백(8px))
    top: '-268px',
    // -(컨테이너크기 - 아이콘크기) / 2
    left: '-60px',
    zIndex: 3000,
    background: 'black',
    padding: '10px 0px',
    borderRadius: '20px',
    textAlign: 'center',
    // 기존 left - (기존 padding(20px) - 모바일용 padding(2px)) / 2
    // 아이콘 크기가 달라서 3.5만큼 더 빼줌
    [theme.breakpoints.down('xs')]: { left: '-72.5px' },
  },
  playbackRateControlHidden: {
    display: 'none',
  },
  cleanSwitchArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1300,
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
  },

  playButtonArea: {
    width: '256px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minWidth: '120px',
    [theme.breakpoints.down('xs')]: {
      gap: '2px',
    },
  },
  cleanSwitch: {
    display: 'flex',
    padding: '4px 8px 4px 8px',
    borderRadius: '9999px',
    backgroundColor: '#000817',
    '&:hover': {
      opacity: '0.8',
    },
    transition: 'opacity 250ms',
    gap: '4px',
    cursor: 'pointer',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      padding: '2px',
      width: '80px',
      height: '28px',
      gap: '0',
      justifyContent: 'space-between',
    },
  },
  cleanSwitchItem: {
    padding: '4px',
    zIndex: 10,
    transition: 'color 250ms',
    fontSize: '14px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
      flex: 1,
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  cleanSwitchItemBackground: {
    position: 'absolute',
    backgroundColor: 'rgba(202, 90, 150, 1.0)',
    borderRadius: '9999px',
    transition: 'left 250ms',
    width: '52px',
    height: '30px',
    top: '3px',
    [theme.breakpoints.down('xs')]: {
      width: '38px',
      height: '20px',
      top: '4px',
      left: '2px !important', // 모바일 기본값 (방송본)
      '&.isClean': {
        left: '40px !important', // 모바일 클린본 위치
      },
    },
  },

  timeGroupContainer: {
    display: 'flex',
    height: '36px',
    margin: '0 6px 0 0',
    '& > div': {
      position: 'relative',
    },
  },
  inputTime: {
    position: 'relative',
    width: '44px',
    height: '36px',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
    },
  },
  upDownButtonContainer: {
    position: 'absolute',
    top: 0,
    right: '2px',
    display: 'flex',
    flexDirection: 'column',
    padding: '2px 0',
    height: '36px',
  },
  upDownIcon: {
    color: '#000',
    '&:hover': {
      cursor: 'pointer',
      color: style.PINK_COLOR,
    },
    '& > svg': {
      fontSize: '14px',
    },
  },
  timeButton: {
    width: '62px',
    margin: '0 2px 0 0',
    backgroundColor: 'gray',
    outline: 'none',
    border: '0px',
    color: '#ffffff',
    whiteSpace: 'nowrap',
  },

  saveButton: {
    width: '80px',
    height: '32px',
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 1.0)',
    backgroundColor: 'rgba(202, 90, 150, 1.0)',
    fontWeight: 'bold',
    fontSize: '1.0em',
    borderRadius: 0,
    cursor: 'pointer',
    marginTop: '12px',
    '&:hover': {
      backgroundColor: 'rgba(202, 90, 150, 0.9)',
    },
  },

  saveIcon: {
    color: '',
  },
  saveIconDisabled: {
    color: 'gray',
    cursor: 'default',
  },
  messageToast: {
    position: 'absolute',
    width: '152px',
    height: '40px',
    // -(컨테이너 높이 + 여백(8px))
    top: '-28px',
    // -(컨테이너크기 - 아이콘크기) / 2
    left: '-54px',
    zIndex: 1000,
    textAlign: 'center',
    pointerEvents: 'none',
    animation: 'fadeIn 0.3s ease-in-out',
    // 기존 left - (기존 padding(20px) - 모바일용 padding(2px)) / 2
    [theme.breakpoints.down('xs')]: { top: '-36px', left: '-63px' },
  },
  loadingIcon: {
    position: 'absolute',
    top: '-10px',
    left: '12px',
    zIndex: 1000,
    textAlign: 'center',
    pointerEvents: 'none',
    animation: 'fadeIn 0.3s ease-in-out',
    [theme.breakpoints.down('xs')]: { top: '-12px', left: '8px' },
  },
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
}));
